import { StoryblokComponent, storyblokEditable } from "@storyblok/react";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

interface IGridProps {
  blok: { headline: string; items: any };
}

const GridContainer = ({ blok }: IGridProps) => {
  const title = blok.headline || "";
  return (
    <Box
      {...storyblokEditable(blok)}
      sx={{
        padding: { xs: "20px 16px 16px 16px", lg: "20px 20px 24px 20px" },
        border: "1px solid #EEEEEE",
        borderRadius: "16px",
      }}
    >
      {title && (
        <Typography
          component="h2"
          sx={{
            marginBottom: "16px",
            color: "#2E263D",
            fontSize: "24px",
            fontWeight: 500,
            lineHeight: "32px",
          }}
        >
          {title}
        </Typography>
      )}
      <Grid container rowSpacing={5} columnSpacing={3}>
        {blok.items.map((blok: any) => (
          <StoryblokComponent blok={blok} key={blok._uid} />
        ))}
      </Grid>
    </Box>
  );
};

export default GridContainer;
